export default __webpack_public_path__ + "static/media/pegi18.a5792e62.svg";